import { createSlice } from "@reduxjs/toolkit";
import DesktopAppManagerService from "../../../../services/desktopAppManagerService";
import EventBus from "../../../eventbus/EventBus";
import {
  ACTIVATE_DESKTOP_APP_VERSION_FAILED,
  ACTIVATE_DESKTOP_APP_VERSION_REQUESTED,
  ACTIVATE_DESKTOP_APP_VERSION_SUCCEED,
  ADD_NEW_DESKTOP_APP_VERSION_FAILED,
  ADD_NEW_DESKTOP_APP_VERSION_REQUESTED,
  ADD_NEW_DESKTOP_APP_VERSION_SUCCEED,
  DEACTIVATE_DESKTOP_APP_VERSION_FAILED,
  DEACTIVATE_DESKTOP_APP_VERSION_REQUESTED,
  DEACTIVATE_DESKTOP_APP_VERSION_SUCCEED,
  DELETE_DESKTOP_APP_VERSION_FAILED,
  DELETE_DESKTOP_APP_VERSION_REQUESTED,
  DELETE_DESKTOP_APP_VERSION_SUCCEED,
} from "../../../eventbus/desktopAppEvents";

const desktopAppSlice = createSlice({
  name: "desktopApp",
  initialState: {
    versions: [],
    versionsCount: 0,
    filterOptions: { page: 1, limit: 10 },
    mode: "old", 
  },
  reducers: {
    updateVersions: (state, action) => {
      state.versions = action.payload;
    },
    updateVersionsCount: (state, action) => {
      state.versionsCount = action.payload;
    },
    updateFilterOptions: (state, action) => {
      state.filterOptions = { ...state.filterOptions, ...action.payload };
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { updateVersions, updateVersionsCount, updateFilterOptions, setMode } =
  desktopAppSlice.actions;

export const selectMode = (state) => state.desktopApp.mode;
export const selectDesktopAppVersions = (state) => state.desktopApp.versions;
export const selectDesktopAppVersionsCount = (state) =>
  state.desktopApp.versionsCount;
export const selectDesktopAppVersionsFilterOptions = (state) =>
  state.desktopApp.filterOptions;

// 🔄 Versiyalarni olish
export const loadDesktopAppVersionsAsync =
  ({ page, limit, ...filters }) =>
  (dispatch, getState) => {
    const { mode } = getState().desktopApp;
    const skip = (page - 1) * limit;
    const params = { skip, limit, ...filters };

    const apiCall =
      mode === "new"
        ? DesktopAppManagerService.getFileVersions(params)
        : DesktopAppManagerService.getDesktopAppVersions(params);

    apiCall
      .then((res) => dispatch(updateVersions(res.data)))
      .catch(() => dispatch(updateVersions([])));
};


export const loadDesktopAppVersionsCountAsync = (params) => (dispatch, getState) => {
  const { mode } = getState().desktopApp;
  const { limit, page, ...other } = params;

  const apiCall =
    mode === "new"
      ? DesktopAppManagerService.getFileVersionsCount(other)
      : DesktopAppManagerService.getDesktopAppVersionsCount(other);

  apiCall
    .then((res) => dispatch(updateVersionsCount(res.data)))
    .catch(() => dispatch(updateVersionsCount(0)));
};

export const addNewDesktopAppVersionAsync = (payload) => (dispatch, getState) => {
    EventBus.dispatch(ADD_NEW_DESKTOP_APP_VERSION_REQUESTED);
  
    const { mode } = getState().desktopApp;
  
    const apiCall =
      mode === "new"
        ? DesktopAppManagerService.addDesktopAppNewVersion(payload) 
        : DesktopAppManagerService.addNewDesktopAppVersion(payload); 
  
    return new Promise((resolve, reject) => {
      apiCall
        .then((res) => {
          EventBus.dispatch(ADD_NEW_DESKTOP_APP_VERSION_SUCCEED, res.data);
          resolve();
        })
        .catch((err) => {
          EventBus.dispatch(ADD_NEW_DESKTOP_APP_VERSION_FAILED, err);
          reject(err);
        });
    });
};
  
  


export const deleteDesktopAppVersionAsync = (id) => (dispatch, getState) => {
    EventBus.dispatch(DELETE_DESKTOP_APP_VERSION_REQUESTED, id);
    const { mode } = getState().desktopApp;
  
    const apiCall =
      mode === "new"
        ? DesktopAppManagerService.deleteDesktopAppNewVersion(id) 
        : DesktopAppManagerService.deleteDesktopAppVersion(id);   
  
    return new Promise((resolve, reject) => {
      apiCall
        .then(() => {
          EventBus.dispatch(DELETE_DESKTOP_APP_VERSION_SUCCEED, id);
          resolve();
        })
        .catch((err) => {
          EventBus.dispatch(DELETE_DESKTOP_APP_VERSION_FAILED, id);
          reject(err);
        });
    });
};


export const activateDesktopAppVersionAsync = (id) => async (dispatch, getState) => {
  EventBus.dispatch(ACTIVATE_DESKTOP_APP_VERSION_REQUESTED, id);
  const { mode } = getState().desktopApp;
  try {
    const response =
      mode === "new"
        ? await DesktopAppManagerService.activateDesktopAppNewVersion(id)
        : await DesktopAppManagerService.activateDesktopAppVersion(id);

    EventBus.dispatch(ACTIVATE_DESKTOP_APP_VERSION_SUCCEED, id);
    return response; 
  } catch (err) {
    EventBus.dispatch(ACTIVATE_DESKTOP_APP_VERSION_FAILED, id);
    throw err;
  }
};

export const deactivateDesktopAppVersionAsync = (id) => async (dispatch, getState) => {
  EventBus.dispatch(DEACTIVATE_DESKTOP_APP_VERSION_REQUESTED, id);
  const { mode } = getState().desktopApp;

  try {
    const response =
      mode === "new"
        ? await DesktopAppManagerService.deactivateDesktopAppNewVersion(id)
        : await DesktopAppManagerService.deactivateDesktopAppVersion(id);

    EventBus.dispatch(DEACTIVATE_DESKTOP_APP_VERSION_SUCCEED, id);
    return response;
  } catch (err) {
    EventBus.dispatch(DEACTIVATE_DESKTOP_APP_VERSION_FAILED, id);
    throw err;
  }
};


// 📄 Filter optionlarni yangilash
export const changeDesktopAppVersionsFilterOptionsAsync =
  (params) => (dispatch) => {
    dispatch(updateFilterOptions(params));
  };

export default desktopAppSlice.reducer;
